// home.js
import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import Fetch from '../../../core/util/core/Fetch';
import config from '../../config/config';

import {
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink,
  Col,
} from "reactstrap";
import classnames from "classnames";
import { chooseProfileFilter } from '../../helpers/chooseProfileFilter';

const Indicators = () => {
  const profileFilter = chooseProfileFilter();
  const [activeTab, setActiveTab] = useState("1");

  const [indicatorsTabs, setIndicatorsTabs] = useState([])

  useEffect(() => {
    const loadData = async () => {
        let indicatorsTabsResponse = null;
        if(profileFilter.governance_room_client_city_id){
            indicatorsTabsResponse = await Fetch.post(`${config.endpoints.backend}governanceroom/clientscities/getById`, { id: profileFilter.governance_room_client_city_id });
            indicatorsTabsResponse = indicatorsTabsResponse.indicators; 
        }

        setIndicatorsTabs(indicatorsTabsResponse)
    };

    loadData();
  }, [])

  return (
    <div className='mr-3 ml-3 mt-3'>
      <Nav tabs>
        {
          indicatorsTabs && indicatorsTabs.map((item, index) => (
            <NavItem>
              <NavLink
                style={{ cursor: "pointer" }}
                className={classnames({ active: activeTab === `${index + 1}` })}
                onClick={() => {
                  setActiveTab(`${index + 1}`);
                }}
              >
                {item.indicator_name}
              </NavLink>
            </NavItem>
          ))
        }
      </Nav>
      <TabContent activeTab={activeTab} className="bg-white">
        {
          indicatorsTabs && indicatorsTabs.map((item, index) => (
            <TabPane tabId={`${index + 1}`}>
              <div style={{
                display: 'flex',
                width: '100%',
                height: '80vh',
                overflowY: 'hidden',
                padding: '1rem 1rem 0'
              }}>
                <iframe
                    src={item.indicator_link}
                    title={`indicator-${index}`}
                    style={{ width: '100%', height: '110%', border: 'none' }}
                    allow="fullscreen"
                  ></iframe>
              </div>
            </TabPane>
          ))
        }
      </TabContent>
      {!indicatorsTabs && <div><p>Ainda não foi cadastrado Dashboard para este município.</p></div>}
    </div>
  );
};

export default Indicators;